export const escapeHtml = (text = '') => {
    const encodeMap = {
        '<': '\\u003C',
        '>': '\\u003E',
    };
    return text.replace(/[<>]/g, match => {
        return encodeMap[match];
    });
};
export const isClient = () => typeof window !== 'undefined';
//# sourceMappingURL=utils.js.map